<div *ngIf="count" class="badge-background" [class.active-tab]="activeTab">
  <div class="activity-badge">
    {{ count }}
  </div>
  <!-- 626262 -->
</div>
